// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../provider/Context.bs.js";
import * as Atom_Cta from "./Atom_Cta.bs.js";
import * as UseToggle from "../../hook/UseToggle.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Type_String from "../../type/Type_String.bs.js";
import * as User_Provider from "../../user/User_Provider.bs.js";
import * as User_Observable from "../../user/User_Observable.bs.js";
import * as UseTrackingAmplitude from "../../hook/UseTrackingAmplitude.bs.js";

function availabilityFromTeaserFavorite(favoriteStatus) {
  if (favoriteStatus) {
    return "Available";
  } else {
    return "NotAvailable";
  }
}

function Atom_FavoriteButton(Props) {
  var teaser = Props.teaser;
  var styleVariationOpt = Props.styleVariation;
  var title = Props.title;
  var availabilityOpt = Props.availability;
  var styleVariation = styleVariationOpt !== undefined ? styleVariationOpt : /* Small */0;
  var availability = availabilityOpt !== undefined ? availabilityOpt : "NotAvailable";
  var trackAmplitude = UseTrackingAmplitude.useUserAction("favorite");
  var match = Curry._1(User_Observable.Favorite.Hook.useStatus, teaser.dsId);
  var remove = match.remove;
  var add = match.add;
  var userStatus = Curry._1(User_Provider.Hook.useUserStatus, undefined);
  var match$1 = Context.I18n.getState(undefined);
  var formaters = match$1.formaters;
  var match$2 = match$1.labels.common;
  var match$3 = UseToggle.make(match.status ? /* Off */1 : /* On */0, (function (param) {
          Curry._1(add, undefined);
        }), (function (param) {
          Curry._1(remove, undefined);
        }), undefined);
  var toggle = match$3.toggle;
  var handleClick = function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    Curry._1(toggle, ev);
    Curry._1(trackAmplitude, undefined);
  };
  var title$1 = Belt_Option.getWithDefault(title, Type_String.Teaser.Title.empty);
  var removeFavoriteTitle = Curry._1(formaters.removeFavorite, Curry._1(Type_String.Teaser.Title.toString, title$1));
  var addFavoriteTitle = Curry._1(formaters.addFavorite, Curry._1(Type_String.Teaser.Title.toString, title$1));
  var match$4 = match$3.state ? (
      styleVariation !== 0 ? [
          addFavoriteTitle,
          match$2.add,
          {
            TAG: /* Favorite */6,
            _0: /* Add */0,
            _1: styleVariation
          }
        ] : [
          undefined,
          addFavoriteTitle,
          {
            TAG: /* Favorite */6,
            _0: /* Add */0,
            _1: styleVariation
          }
        ]
    ) : (
      styleVariation !== 0 ? [
          removeFavoriteTitle,
          match$2.remove,
          {
            TAG: /* Favorite */6,
            _0: /* Remove */1,
            _1: styleVariation
          }
        ] : [
          undefined,
          removeFavoriteTitle,
          {
            TAG: /* Favorite */6,
            _0: /* Remove */1,
            _1: styleVariation
          }
        ]
    );
  if (userStatus >= 2) {
    return null;
  }
  if (availability !== "Available") {
    return null;
  }
  var tmp = {
    label: match$4[1],
    onClick: handleClick,
    style: match$4[2]
  };
  var tmp$1 = match$4[0];
  if (tmp$1 !== undefined) {
    tmp.screenReadersLabel = tmp$1;
  }
  return React.createElement(Atom_Cta.Button.make, tmp);
}

var make = Atom_FavoriteButton;

export {
  availabilityFromTeaserFavorite ,
  make ,
}
/* react Not a pure module */
